import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { patchItemReaction } from '../../../api/items';

import { REQUEST } from '../../../constants/request';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeItemWithUserData } from '../../../utils/items';

export const editItemReaction = createAsyncThunk(
  'items/editItemReaction',
  async (urlParams, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await patchItemReaction(
        urlParams,
        {
          cancelToken: source.token,
        },
      );
      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const itemCIDKey = generateItemCIDKey(path);
      const itemsStore = getState().items;

      return (
        itemsStore.items.item.actions.reaction.request[itemCIDKey]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const editItemReactionExtraReducers = builder => {
  builder
    .addCase(editItemReaction.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.items.item.actions.reaction.request,
        action,
        generateItemCIDKey(action.meta.arg.path),
      );
    })
    .addCase(editItemReaction.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.items.item.actions.reaction.request[itemCIDKey],
        action,
        () => {
          state.items.item.byId[itemCIDKey] = action.payload;

          if (!state.items.item.allIds.includes(itemCIDKey)) {
            state.items.item.allIds.push(itemCIDKey);
          }
        },
      );
    })
    .addCase(editItemReaction.rejected, (state, action) => {
      handleRequestRejection(
        state.items.item.actions.reaction.request[
          generateItemCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
